import { keyBy, flatten, round } from 'lodash-es';
export function calculateEmissions(userAnswersList) {
    var _a, _b, _c;
    const answersByQuestionId = keyBy(flatten(userAnswersList).filter((a) => !a.isOldAnswer), 'questionId');
    const emissionsCoefficient = ((_a = answersByQuestionId['used_means_of_transport']) === null || _a === void 0 ? void 0 : _a.emissions) || 0;
    const km = parseFloat((_c = (_b = answersByQuestionId['mean_distance']) === null || _b === void 0 ? void 0 : _b.text) !== null && _c !== void 0 ? _c : '0');
    const emissions = round(emissionsCoefficient * km, 2);
    return emissions;
}
